<template>
  <div>
  <table class="table-bordered table-hover tbl datatables" style="width:100%;">
    <thead class="thead-default tablehead">
      <tr>
        <!-- <td class="text-center" v-if="JobType === 'RVP' "><input type="checkbox"  @click="selectAllShipments($event)" v-model="checkAll" ></td> -->
        <th class="text-center">Shipping Id</th>
        <th class="text-center">Handover Date</th>
        <th class="text-center">Asign Date</th>
        <th class="text-center">Shipment Type</th>
        <th class="text-center">Delivery User Name</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item,index) in pendingForReturnList" :key="index" class="text-center">
      <!-- <td v-if="JobType === 'RVP' "><input type="checkbox"  :value="item.shippingid" v-model="selectedReverseShipmentData" ></td> -->
      <td>{{item.shippingid}}</td>
      <td>{{item.handoverdate | batchCreatedDateFormat}}</td>
      <td>{{item.AssignDate | batchCreatedDateFormat}}</td>
      <td>{{item.shipmenttype}}</td>
      <td>{{item.DeliveryUserName}}</td>
    </tr>
    <tr v-if="pendingForReturnList.length==0">
      <td colspan="35" align="center">No record found</td>
    </tr>
  </tbody>
  </table><br>
  </div>
</template>


<script>
import Paginate from 'vuejs-paginate'
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'

export default{
  name: "pendingForReturn",
  components: {
    Paginate,VueElementLoading
  },
  data:function(){
  return {
    selectedReverseShipmentData: [],
    // checkAll:false
    }
  },
  filters: {
      batchCreatedDateFormat:function(date){
        if(date==null)return ''
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
      }
    },
  mounted(){

  },
  props: {
    pendingForReturnList: {
      type: Array,
      required: true
    },
    // JobType: {
    //   type: String,
    //   // required: true,
    // }
  },
  methods:{
    // selectAllShipments(ev){
    //   this.selectedReverseShipmentData = [];
    //   if (ev.target.checked == true) {
    //     $.each(this.pendingForReturnList, (key,value) => {
    //       this.selectedReverseShipmentData.push(value.shippingid);
    //     })
    //   }
    // }
  }
}
</script>


<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// src/views/components/common/pendingForReturn.vue?38c4472e